import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import '../css/listview.css';
import {address} from '../common-util'

const ListView = ({currentYear}) => {

  console.log('INSIDE LIST VIEW', currentYear)

  const { 
    getAccessTokenSilently,
  } = useAuth0();


const [allmonthUserEvents, setallmonthUserEvents] = useState([]);

async function getallmonthUserEvents(currentYear) {
    // console.log('calling api')
  try {
    const token = await getAccessTokenSilently();
    const res = await axios.get(`${address}allsortmonthEvents?year=${currentYear}`, {
    headers: {
      authorization: `Bearer ${token}`
    }
  })
  const allmonthUserEvents = res.data; //using axios and it parses the body
  console.log(res);
  setallmonthUserEvents(Object.values(allmonthUserEvents));

  } catch (error) {
    console.log(error.message)
  }
}

let MonthNameArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    useEffect(() => {
      getallmonthUserEvents(currentYear)
    }, [currentYear])
 
  return (

    <div className="container">

      {
        [...Array(12)].map((_, i) => 
          <div className={`month-div ${MonthNameArr[i]}`} key={i}> <h2>{MonthNameArr[i]}</h2>
          {allmonthUserEvents?.filter(e => +e.month_of_events === i + 1)
            .map((e, i) => 
            <div 
            key={i}
            className="events-text"
            >
            <p> {i + 1}.- {e.event_name}</p> <p>|</p> <p>{e.event_date.substr(0, 10)}</p> <p>|</p>  <p>{e.current_age}</p> 
            </div>)
          }
          </div>)
      }
    
    </div>

  );
};

export default ListView;